module.exports = __webpack_public_path__ + "static/media/repeat_arrow.2a8156f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/repeat_arrow.svg
// module id = 832
// module chunks = 0